import { render, staticRenderFns } from "./AmountDwellTime.vue?vue&type=template&id=6f820c1b"
import script from "./AmountDwellTime.vue?vue&type=script&lang=js"
export * from "./AmountDwellTime.vue?vue&type=script&lang=js"
import style0 from "./AmountDwellTime.vue?vue&type=style&index=0&id=6f820c1b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports